import cls from "../CustomRadio/customRadio.module.scss"
import {ChangeEvent, Dispatch, FC, SetStateAction, useState} from "react";
import {optionItemType} from "../../../types/homePageTypes";
import {handleChangeOutsideForMulti} from "../../../components/ForCWV/InnerPageProduct/helpers";

interface ICustomSelect {
    selectArray: Array<optionItemType>;
    setOptionQuantity: Dispatch<SetStateAction<optionItemType[]>>
    optionQuantity: Array<optionItemType>
}

const CustomCheckbox: FC<ICustomSelect> = (
    {
        selectArray,
        setOptionQuantity,
        optionQuantity,
    }
) => {
    const defaultValueExist = selectArray?.find((item) => !!item.is_default)
    const [
        optionArr,
        setOptionArr
    ] = useState<Array<optionItemType>>(defaultValueExist ? [defaultValueExist] : []);
    const handleChangeInside = (e: ChangeEvent<HTMLInputElement>) => {
        const existThisVal = optionArr.findIndex(option => String(option?.id) === e.target.id);
        const value = JSON.parse(e.target.value);
        if (existThisVal === -1) {
            setOptionArr((prevState) => [...prevState, value])
        } else {
            setOptionArr((prevState) => prevState.filter((_, index) => existThisVal !== index))
        }
    }
    return (
        <div className={cls.main}>
            {selectArray?.map((elem) => {
                return (
                    <div className={cls.optionMain} key={elem.id as number}>
                        <input
                            type="checkbox"
                            id={`${elem.id}`}
                            name="option"
                            value={JSON.stringify(elem)}
                            onChange={(event) => {
                                handleChangeInside(event);
                                handleChangeOutsideForMulti(event, optionQuantity, setOptionQuantity);
                            }}
                            defaultChecked={defaultValueExist && elem.id === defaultValueExist.id}
                        />
                        <label htmlFor={`${elem.id}`}>{elem.name}</label>
                    </div>
                )
            })}
        </div>
    )
};

export default CustomCheckbox;
